/* eslint-disable react-hooks/exhaustive-deps */
import { FunctionComponent, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Grid, SvgIconProps } from '@material-ui/core'
import {
  MdLocalOffer,
  MdMonetizationOn,
  MdKeyboardBackspace,
} from 'react-icons/md'

import { colors } from 'shared/styles/colors'

import { IFindDetalhesViagemComVPO } from 'modules/valePedagio/domain/usecases/FindDetalhesViagemComVPO'

import {
  ContainerCards,
  Content,
  Detalhes,
  SubtitleItem,
  TitleArea,
  TitleItem,
} from './styles'
import {
  convertDateToStringBrazilianPattern,
  numberToCurrency,
} from 'shared/utils/formatters'
import LoadingBackdrop from 'shared/components/LoadingBackdrop'
import SnackBar from 'shared/components/SnackBar'
import LabelValue from '../components/LabelValue'

type TProp = {
  findDetalhesViagemComVPO: IFindDetalhesViagemComVPO
}

const DetalhesViagem: FunctionComponent<TProp> = ({
  findDetalhesViagemComVPO,
}) => {
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const [detalhesViagem, setDetalhesViagem] = useState(null)
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    const init = async () => {
      setLoading(true)
      try {
        const state = history.location.state as {
          params: {
            id?: number
            documento?: string
          }
        }
        const response = await findDetalhesViagemComVPO.execute(
          state.params?.id,
          state.params?.documento,
        )
        setDetalhesViagem(response)
        setLoading(false)
      } catch (error) {
        setError(true)
        if (error instanceof Error) {
          setErrorMessage(error.message)
        } else {
          setErrorMessage('Erro buscar motoristas')
        }
        setLoading(false)
      }
    }

    init()
  }, [])

  const getMdKeyboardBackspace: React.ComponentType<SvgIconProps> = () => (
    <MdKeyboardBackspace
      style={{
        width: 60,
        height: 15,
        color: colors.blue,
        transform: 'scaleX(-1)',
      }}
    />
  )

  return (
    <>
      {loading && <LoadingBackdrop open={loading} color={colors.green} />}
      <Content>
        <ContainerCards>
          <Grid container direction="column">
            <Detalhes>
              <TitleArea>Viagem em aberto</TitleArea>

              <Grid container>
                <Grid item xs={6}>
                  <LabelValue
                    title="Distância"
                    subtitle1={`${detalhesViagem?.distancia ?? 0} km`}
                  />
                </Grid>
                <Grid item xs={6}>
                  <LabelValue
                    title="Rota"
                    subtitle1={detalhesViagem?.origem ?? 'Sem origem'}
                    subtitle2={detalhesViagem?.destino ?? 'Sem destino'}
                    icon={getMdKeyboardBackspace}
                  />
                </Grid>
              </Grid>

              <Grid container>
                <Grid item xs={6}>
                  <LabelValue
                    icon={MdLocalOffer}
                    title="TAG"
                    subtitle1={detalhesViagem?.provedor ?? 'Sem Tag'}
                  />
                </Grid>
                <Grid item xs={6}>
                  <LabelValue
                    icon={MdMonetizationOn}
                    title="Saldo total"
                    subtitle1={numberToCurrency(
                      detalhesViagem?.saldoTotal ?? 0,
                    )}
                  />
                </Grid>
              </Grid>

              <Grid container>
                <Grid item xs={6}>
                  <LabelValue
                    icon={MdMonetizationOn}
                    title="Utilizado"
                    subtitle1={numberToCurrency(
                      detalhesViagem?.saldoUtilizado ?? 0,
                    )}
                  />
                </Grid>
                <Grid item xs={6}>
                  <LabelValue
                    icon={MdMonetizationOn}
                    title="Estorno"
                    subtitle1={numberToCurrency(detalhesViagem?.residual ?? 0)}
                  />
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <LabelValue
                  title="Previsão de estorno em conta"
                  subtitle1={convertDateToStringBrazilianPattern(
                    detalhesViagem?.previsaoEstorno ?? new Date(),
                  )}
                />
              </Grid>

              <Grid container direction="row">
                <Grid item xs={6}>
                  <TitleArea style={{ color: colors.black }}>
                    Disponíveis
                  </TitleArea>
                  {detalhesViagem?.compradas.map((value, idx) => (
                    <Grid
                      container
                      direction="column"
                      key={value.nome}
                      style={{ marginBottom: 10 }}
                    >
                      <TitleItem style={{ color: colors.gray }}>
                        {value?.nome}
                      </TitleItem>
                      <SubtitleItem style={{ color: colors.gray }}>
                        {numberToCurrency(value?.valor)}
                      </SubtitleItem>
                    </Grid>
                  ))}
                </Grid>

                <Grid item xs={6}>
                  <TitleArea style={{ color: colors.black }}>
                    Utilizadas
                  </TitleArea>
                  {detalhesViagem?.utilizadas.map((value, idx) => (
                    <Grid
                      container
                      direction="column"
                      key={value.nome}
                      style={{ marginBottom: 10 }}
                    >
                      <TitleItem style={{ color: colors.green }}>
                        {value?.nome}
                      </TitleItem>
                      <SubtitleItem style={{ color: colors.black }}>
                        {numberToCurrency(value?.valor)}
                      </SubtitleItem>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Detalhes>
          </Grid>
        </ContainerCards>
      </Content>
      <SnackBar
        open={error}
        setOpen={setError}
        severity="error"
        message={errorMessage}
        horizontal="right"
      />
    </>
  )
}

export default DetalhesViagem
